module.exports = __webpack_public_path__ + "img/40.070d30e4.jpg";